var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "folderAddIconTitle"
  }, "Add to folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "folderAddIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5H9L10 7H21V19H3V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10V16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderAdd);
export default __webpack_public_path__ + "static/media/folder-add.fe8de6d0c2b7673d2185e7c1ad027a72.svg";
export { ForwardRef as ReactComponent };